import $apiJSON from 'http/apiJSON'

const BASE = '/employees'

export const wizardStep = (payload) => $apiJSON.post(`${BASE}/enroll-wizard/`, payload)
export const fullEmployee = (id) => $apiJSON.get(`${BASE}/${id}/full/`)
export const patchSection = (id, section, payload) =>
  $apiJSON.patch(`${BASE}/${id}/${section}/`, payload)
export const employeeFiles = (id) => $apiJSON.get(`${BASE}/${id}/files/`)
export const uploadEmployeeFile = (id, fd) =>
  $apiJSON.post(`${BASE}/${id}/files/`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export default { wizardStep, fullEmployee, patchSection, employeeFiles, uploadEmployeeFile }
